import React, { useState, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import ContactModal from './ContactModal';

const Footer = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  // Secret admin access — Triple-click on OG logo within 1.5s
  const logoClickTimes = useRef([]);
  
  const handleLogoTripleClick = () => {
    const now = Date.now();
    logoClickTimes.current.push(now);
    
    // Keep only the last 3 clicks
    if (logoClickTimes.current.length > 3) {
      logoClickTimes.current = logoClickTimes.current.slice(-3);
    }
    
    if (logoClickTimes.current.length >= 3) {
      const first = logoClickTimes.current[logoClickTimes.current.length - 3];
      const last = logoClickTimes.current[logoClickTimes.current.length - 1];
      if (last - first <= 1500) {
        logoClickTimes.current = [];
        // Use window.location.href for cross-router navigation
        // (admin routes are in a separate BrowserRouter instance)
        window.location.href = '/ogd-access-gate';
      }
    }
  };

  return (
    <>
      {/* CTA Section */}
      <section id="contact" className="bg-emerald-700 py-20 lg:py-28">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="font-display text-3xl lg:text-4xl text-white mb-4">
            {language === 'fr' 
              ? 'Prêt à investir dans l\'avenir ?'
              : 'Ready to invest in the future?'}
          </h3>
          <p className="text-emerald-100/80 text-lg mb-8 max-w-xl mx-auto">
            {language === 'fr'
              ? 'Notre équipe est à votre disposition pour répondre à toutes vos questions.'
              : 'Our team is available to answer all your questions.'}
          </p>
          <Button
            onClick={() => setIsContactOpen(true)}
            className="bg-white text-emerald-700 hover:bg-emerald-50 px-8 py-6 text-base font-medium"
            data-testid="footer-contact-button"
          >
            {language === 'fr' ? 'Échangeons' : 'Let\'s talk'}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </section>

      {/* Footer — Signature fine */}
      <footer
        className="relative z-50"
        style={{ backgroundColor: '#004d40' }}
        data-testid="site-footer"
      >
        <div className="max-w-7xl mx-auto px-6 py-5 pb-16 sm:pb-5 flex flex-col sm:flex-row items-start sm:items-center justify-center gap-3 sm:gap-8 sm:text-center">
          {/* OG Logo — Triple-click trigger */}
          <div
            onClick={handleLogoTripleClick}
            className="flex items-center gap-3 cursor-default select-none"
            data-testid="footer-logo"
          >
            <img
              src="/assets/logos/logo-blanc.png"
              alt="One Green Dev"
              className="h-7 w-auto object-contain opacity-70"
            />
            <p className="text-white/70 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              © {currentYear} One Green Dev. {language === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}
            </p>
          </div>
          <p className="text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            <span className="text-white/50">
              {language === 'fr' ? 'Conçu par ' : 'Crafted with expertise by '}
            </span>
            <a
              href="https://www.relaisit.com"
              target="_blank"
              rel="noopener noreferrer"
              className="relative font-bold text-white transition-colors duration-300 hover:text-emerald-300
                after:content-[''] after:absolute after:left-0 after:bottom-[-2px] after:w-0 after:h-[1px]
                after:bg-emerald-300 after:transition-all after:duration-300 hover:after:w-full"
              data-testid="relais-it-link"
            >
              Relais IT
            </a>
          </p>
        </div>
      </footer>

      {/* Contact Modal */}
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </>
  );
};

export default Footer;
